import { render, staticRenderFns } from "./InputCorreo.vue?vue&type=template&id=87203d82&scoped=true"
import script from "./InputCorreo.vue?vue&type=script&lang=js"
export * from "./InputCorreo.vue?vue&type=script&lang=js"
import style0 from "./InputCorreo.vue?vue&type=style&index=0&id=87203d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87203d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VForm,VIcon,VTextField})
